/**
 * Created by razial on 21.06.2024.
 */

const Products = {};

Products.initialize = function () {
    Object.assign(Products, {
        buyExp10: {
            boughtMessage: "Shop.BuyExp10.BoughtMessage",
            reward: RewardsConfig.BuyExp10
        },
        buyExp150: {
            boughtMessage: "Shop.BuyExp150.BoughtMessage",
            reward: RewardsConfig.BuyExp150
        },

        unlimitedLives: {
            boughtMessage: "UnlimitedLivesBought",
            reward: RewardsConfig.UnlimitedLives,
            icon: "unlimitedLives_png",
            animation: "animation",
            prefab: bundles.tile_shop.jsons.livesproducttile_prefab_json,
            isEnabled: function () {
                return cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_REGULAR;
            }
        },

        cheapProduct: {
            reward: RewardsConfig.CheapProduct,
            rewardsIcon: "gold_small_png",
            icon: "shop_gold_very_small_png"
        },
        gold500: {
            reward: RewardsConfig.Gold500,
            rewardsIcon: "gold_small_png",
            icon: "shop_gold_very_small_png"
        },
        gold1800: {
            oldPrice: 1.99,
            label: 1800,
            reward: RewardsConfig.Gold1800,
            rewardsIcon: "gold_small_png",
            icon: "shop_gold_small_png"
        },
        gold3800: {
            reward: RewardsConfig.Gold3800,
            rewardsIcon: "gold_small_png",
            icon: "shop_gold_medium_png"
        },
        gold6000: {
            clanGift: true,
            oldPrice: 5.99,
            label: 6000,
            reward: RewardsConfig.Gold6000,
            rewardsIcon: "gold_small_png",
            icon: "shop_gold_large_png"
        },
        gold25000: {
            clanGift: true,
            reward: RewardsConfig.Gold25000,
            rewardsIcon: "gold_small_png",
            icon: "shop_gold_huge_png"
        },

        starterPack0: {
            boughtMessage: "StarterPack.Bought",
            boughtMessageParams: {
                title: "StarterPack0.Title"
            },
            reward: RewardsConfig.Packs && RewardsConfig.Packs[0],
            stage: 0,
            mainSceneOnly: true
        },
        starterPack: {
            boughtMessage: "StarterPack.Bought",
            boughtMessageParams: {
                title: "StarterPack1.Title"
            },
            reward: RewardsConfig.Packs && RewardsConfig.Packs[1],
            stage: 1,
            mainSceneOnly: true
        },
        starterPack2: {
            boughtMessage: "StarterPack.Bought",
            boughtMessageParams: {
                title: "StarterPack2.Title"
            },
            reward: RewardsConfig.Packs && RewardsConfig.Packs[2],
            stage: 2,
            mainSceneOnly: true
        },

        piggybank500: {},
        piggybank1800: {},
        piggybank6000: {},
        piggybank25000: {},

        subsWeek: {
            boughtMessage: "Shop.SubsWeek.BoughtMessage",
            icon: "prem_tile_icon",
            clanGift: true
        },
        subsMonth: {
            boughtMessage: "Shop.SubsMonth.BoughtMessage",
            icon: "prem_tile_icon",
            clanGift: true,
            prefab: bundles.tile_shop.jsons.subscriptiontile_prefab_json,
            isEnabled: function () {
                return Subscription.IsAvailable() && cleverapps.environment.isMainScene() && cleverapps.meta.getSelectedLocation().locationConfig.isMain
                    && (cleverapps.subscription.isActive() || cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_REGULAR);
            },
            isAttention: function () {
                return Boolean(cleverapps.subscription && cleverapps.subscription.needsAttention());
            }
        },

        subsWeekTest: {
            boughtMessage: "Shop.SubsWeek.BoughtMessage",
            icon: "prem_tile_icon"
        },
        subsMonthTest: {
            boughtMessage: "Shop.SubsMonth.BoughtMessage",
            icon: "prem_tile_icon"
        },

        // OLD PRODUCTS COMPATIBILITY
        sweetPack: {
            boughtMessage: "Shop.sweetPack.boughtMessage",
            reward: RewardsConfig.SweetPack,
            icon: "pack500_png",
            prefab: bundles.tile_shop.jsons.packproducttile_prefab_json
        },
        jamPack: {
            boughtMessage: "Shop.jamPack.boughtMessage",
            reward: RewardsConfig.JamPack,
            icon: "pack1800_png",
            prefab: bundles.tile_shop.jsons.packproducttile_prefab_json
        },
        tastyPack: {
            boughtMessage: "Shop.tastyPack.boughtMessage",
            reward: RewardsConfig.TastyPack,
            icon: "pack3800_png",
            prefab: bundles.tile_shop.jsons.packproducttile_prefab_json
        },
        honeyPack: {
            boughtMessage: "Shop.honeyPack.boughtMessage",
            reward: RewardsConfig.HoneyPack,
            icon: "pack6000_png",
            prefab: bundles.tile_shop.jsons.packproducttile_prefab_json
        },
        epicPack: {
            boughtMessage: "Shop.epicPack.boughtMessage",
            reward: RewardsConfig.EpicPack,
            icon: "pack25000_png",
            prefab: bundles.tile_shop.jsons.packproducttile_prefab_json
        },

        noAds: {
            boughtMessage: "NoAds.Bought",
            reward: RewardsConfig.NoAds
        },

        kit1: {
            boughtMessage: "Kit1.Bought",
            restoreReward: RewardsConfig.Kit1
        },
        kit2: {
            boughtMessage: "Kit2.Bought",
            restoreReward: RewardsConfig.Kit2
        },
        kit3: {
            boughtMessage: "Kit3.Bought",
            restoreReward: RewardsConfig.Kit3
        },
        kit4: {
            boughtMessage: "Kit4.Bought",
            restoreReward: RewardsConfig.Kit4
        },
        kit5: {
            boughtMessage: "Kit5.Bought",
            restoreReward: RewardsConfig.Kit5
        },
        kit6: {
            boughtMessage: "Kit6.Bought",
            restoreReward: RewardsConfig.Kit6
        },
        kit7: {
            boughtMessage: "Kit7.Bought",
            restoreReward: RewardsConfig.Kit7
        },
        kit8: {
            boughtMessage: "Kit8.Bought",
            restoreReward: RewardsConfig.Kit8
        },
        kit10: {
            boughtMessage: "Kit10.Bought",
            restoreReward: RewardsConfig.Kit10,
            oldPrice: 35.99
        },
        kit16: {
            boughtMessage: "Kit16.Bought",
            restoreReward: RewardsConfig.Kit16
        },
        kit20: {
            boughtMessage: "Kit20.Bought",
            restoreReward: RewardsConfig.Kit20,
            oldPrice: 35.99
        },
        kit30: {
            boughtMessage: "Kit30.Bought",
            restoreReward: RewardsConfig.Kit30
        },
        kit40: {
            boughtMessage: "Kit40.Bought",
            restoreReward: RewardsConfig.Kit40
        },
        kit50: {
            boughtMessage: "Kit50.Bought",
            restoreReward: RewardsConfig.Kit50
        },
        kit100: {
            boughtMessage: "Kit100.Bought",
            restoreReward: RewardsConfig.Kit100
        }
    });

    if (cleverapps.config.name === "garden") {
        Object.assign(Products, {
            hard2: {
                reward: RewardsConfig.Hard2,
                rewardsIcon: "gold_small_png",
                icon: "shop_gold_very_small_png"
            },
            hard5: {
                reward: RewardsConfig.Hard5,
                rewardsIcon: "gold_small_png",
                icon: "shop_gold_small_png"
            },
            hard10: {
                reward: RewardsConfig.Hard10,
                rewardsIcon: "gold_small_png",
                icon: "shop_gold_medium_png"
            },
            hard20: {
                reward: RewardsConfig.Hard20,
                rewardsIcon: "gold_small_png",
                icon: "shop_gold_large_png"
            },
            hard45: {
                reward: RewardsConfig.Hard45,
                rewardsIcon: "gold_small_png",
                icon: "shop_gold_huge_png"
            },
            hard100: {
                reward: RewardsConfig.Hard100,
                rewardsIcon: "gold_small_png",
                icon: "shop_gold_giant_png"
            }
        });

        Products.gold25000.reward = { hard: 15000 };
    }

    if (cleverapps.config.type === "merge") {
        Object.assign(Products, {
            coins350: {
                reward: RewardsConfig.Coins350,
                icon: "shop_coins_very_small_png",
                boughtMessage: "Product.SoftCurrencyBought"
            },
            coins1100: {
                reward: RewardsConfig.Coins1100,
                icon: "shop_coins_small_png",
                boughtMessage: "Product.SoftCurrencyBought"
            },
            coins3000: {
                reward: RewardsConfig.Coins3000,
                icon: "shop_coins_medium_png",
                boughtMessage: "Product.SoftCurrencyBought"
            },
            coins7000: {
                reward: RewardsConfig.Coins7000,
                icon: "shop_coins_large_png",
                boughtMessage: "Product.SoftCurrencyBought"
            },
            expeditionPack: {
                boughtMessage: "Shop.expeditionPack.boughtMessage",
                restoreReward: RewardsConfig.ExpeditionPack
            },
            growthFund: {
                boughtMessage: "Shop.growthFund.boughtMessage",
                value: "800%",
                icon: "growth_fund_icon",
                mainSceneOnly: true,
                clanGift: true,
                restoreReward: RewardsConfig.GrowthFund,
                prefab: bundles.tile_shop.jsons.growthfundtile_prefab_json,
                isEnabled: function () {
                    return cleverapps.growthFund && cleverapps.environment.isMainScene() && cleverapps.meta.getSelectedLocation().locationConfig.isMain
                        && (cleverapps.growthFund.isBought() || cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_REGULAR);
                },
                isAttention: function () {
                    return Boolean(cleverapps.growthFund && cleverapps.growthFund.needsAttention());
                }
            },

            island1: {
                boughtMessage: "Island1.Bought",
                restoreReward: RewardsConfig.Island1
            },
            island2: {
                boughtMessage: "Island2.Bought",
                restoreReward: RewardsConfig.Island2
            },
            island5: {
                boughtMessage: "Island5.Bought",
                restoreReward: RewardsConfig.Island5
            },
            island10: {
                boughtMessage: "Island10.Bought",
                restoreReward: RewardsConfig.Island10
            },
            island15: {
                boughtMessage: "Island15.Bought",
                restoreReward: RewardsConfig.Island15
            },
            island20: {
                boughtMessage: "Island20.Bought",
                restoreReward: RewardsConfig.Island20
            },
            island30: {
                boughtMessage: "Island30.Bought",
                restoreReward: RewardsConfig.Island30
            },
            island45: {
                boughtMessage: "Island45.Bought",
                restoreReward: RewardsConfig.Island45
            }
        });
    }
};
